import { getPriceChangeDetails } from '@/utils/coins/formatNumber';

const toNumber = (value: unknown): number | null => {
    const n = typeof value === 'string' ? parseFloat(value) : Number(value);
    return Number.isFinite(n) ? n : null;
};

/**
 * One server-rendered sentence about the 7-day and 30-day change, for the chart section (the chart
 * itself draws in the browser, so without this the HTML said nothing about the trend):
 * «قیمت دلار آمریکا در ۷ روز گذشته ۲٫۱۰٪ رشد داشته و در ۳۰ روز گذشته ۵٫۴۰٪ افت داشته است.»
 * null when neither number is known.
 */
export const rangeChangeSentence = (
    displayName: string,
    changes?: Record<string, unknown> | null,
): string | null => {
    const clauses: string[] = [];
    for (const [key, label] of [
        ['7d', '۷ روز'],
        ['30d', '۳۰ روز'],
    ] as const) {
        const value = toNumber(changes?.[key]);
        if (value === null) continue;
        const { text, onlyText } = getPriceChangeDetails(value);
        clauses.push(
            text
                ? `در ${label} گذشته ${text} ${onlyText} داشته`
                : `در ${label} گذشته تغییری نداشته`,
        );
    }
    if (clauses.length === 0) return null;
    return `قیمت ${displayName} ${clauses.join(' و ')} است.`;
};
